import { getTenantInfo, getAllTenant } from '../../api';
const GET_TENANT = 'GET_TENANT';
const GET_ALL_TENANT = 'GET_ALL_TENANT';
const UPDATE_INFO = 'UPDATE_INFO';

const initState = {
  loginAdmin: '',
  chosenTenant: '',
  tenantList: [],
  tenantInfo: {}
};

export function tenant(state=initState, action) {
  switch (action.type) {
    case GET_ALL_TENANT:
      return {...state, ...action.payload};
    case GET_TENANT:
      return {...state, tenantInfo: action.payload, chosenTenant: action.payload.companyName};
    case UPDATE_INFO:
      return {...state, ...action.payload};
    default:
      return state;
  }
}

export function updateInfo(body) {
  return {type: UPDATE_INFO, payload: body};
}

export function getTenantList(body) {
  return dispatch=>{
    getAllTenant(body)
      .then(res=>{
        let data = res.data || {};
        let list = data.list || [];
        let payloadList = list.reverse();
        let chosenIndex = sessionStorage.getItem("chosenIndex");
        if (chosenIndex !== '0' && payloadList[chosenIndex]) {
          dispatch({
            type: GET_ALL_TENANT,
            payload: {
              tenantList: payloadList,
              tenantInfo: payloadList[chosenIndex],
              chosenTenant: payloadList[chosenIndex].companyName
            }
          });
        } else {
          sessionStorage.setItem("chosenTenant", payloadList[0].companyName);
          sessionStorage.setItem("chosenIndex", 0);
          sessionStorage.setItem("chosenTenantName", payloadList[0].name);
          dispatch({
            type: GET_ALL_TENANT,
            payload: {
              tenantList: payloadList,
              tenantInfo: payloadList[0],
              chosenTenant: payloadList[0].companyName,
            }
          });
        }
      })
      .catch(e=>{
        console.log(e);
      });
  };
}

export function getOneTenant(body, header) {
  return dispatch=>{
    getTenantInfo(body, header)
      .then(res => {
        let data = res.data || {};
        dispatch({type: GET_TENANT, payload: data});
      })
      .catch(err=>{
        console.log(err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/reducer/tenant.js